<template>
    <ul class="mark">
        <li v-for="(text, index) in list" :key="index" :class="{'selected': isSelected(text)}">
            <template v-if="text !== 'icon_next'">
                {{ `shopcart.${text}` | trans }}
            </template>
            <i :class="icons(text)" v-if="text === 'icon_next'"/>
        </li>
    </ul>
</template>

<script>
    import { breadcrumb } from '../router/index';

    export default {
        name: 'breadcrumb',
        data() {
            return {
                list: breadcrumb
            };
        },
        methods: {
            isSelected(name) {
                let routeName = this.$route.name;
                if (routeName === 'fail') {
                    routeName = 'check';
                }
                return routeName === name;
            },
            icons(text) {
                const icon = this.$options.filters.trans(`shopcart.${text}`);
                return icon;
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/Breadcrumb.vue